import { useEffect, useState } from 'react';
import * as S from './styles.ts';
import { Button, Input, P, Select } from '@template/components';
import { useTypedSelector } from '@/redux/helpers/hooks.ts';

interface ISearchTabProps {
  context: 'local' | 'international';
  onSearch: (number: string) => void;
  loading: boolean;
}

const isNumber = (input: string) => {
  const numericRegex = /^\d{9,}$/;
  return numericRegex.test(input);
};

export const SearchTab = ({ context, onSearch, loading }: ISearchTabProps) => {
  const siteVersion = useTypedSelector(
    (state) => state.store.site_version.currency
  );
  const countries = useTypedSelector((state) => state.helpers.countries);

  const [countryCode, setCountryCode] = useState<number | null>(null);
  const [searchValue, setSearchValue] = useState('');

  const isGbp = siteVersion === 'GBP';

  const handleSearch = async () => {
    const cleanedNumberString = searchValue.replace(/^\++/, '');
    let searchString = '';
    if (context === 'international') {
      searchString = `${countryCode}${cleanedNumberString}`;
    } else {
      searchString = `${isGbp ? '44' : '1'}${cleanedNumberString}`;
    }
    onSearch(searchString);
  };

  const availableCountries = [
    ...countries.map((country) => ({
      label: `(+${country.calling_code}) ${country.name} `,
      key: country.calling_code,
    })),
    {
      label: '(+800) International Freephone',
      key: 800,
    },
  ];

  useEffect(() => {
    if (availableCountries.length > 0) {
      setCountryCode(availableCountries[0].key);
    }
  }, [availableCountries.length]);

  return (
    <S.SearchTabContainer
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch();
        return false;
      }}
    >
      <S.SearchGroup>
        <P>Phone Number</P>
        <S.SearchInput>
          {context === 'international' && (
            <Select
              options={availableCountries}
              variant='solid'
              selected={countryCode}
              onChange={setCountryCode}
              search
              fullWidth
            />
          )}
          <Input
            loading={loading}
            prefix={
              context === 'local' ? (isGbp ? 'UK (+44)' : 'US (+1)') : null
            }
            hint='Enter a full number to view predicted call costs.'
            fullWidth
            value={searchValue}
            onChange={(val) => {
              setSearchValue(val);
            }}
          />
        </S.SearchInput>
      </S.SearchGroup>
      <S.SearchButton>
        <Button size='md' type='submit'>
          Search Call Rates
        </Button>
      </S.SearchButton>
    </S.SearchTabContainer>
  );
};
